import { SiteData } from "../types/account";

export const getSiteNames = (sites: SiteData[]) => {
  const names: any = {};
  sites.forEach(site => { names[site.id] = site.name });
  return names;
}